import { createContext, useContext } from 'react';
import { UserInContext } from './UserInContext';

export const UserContext = createContext<UserInContext | null>(null);

export const useUserContext = () => useContext(UserContext);
